import { getOperationAST } from 'graphql';
import { ApolloLink, FetchResult } from '@apollo/client';

// implementation of the RFC here: https://microsoft.sharepoint-df.com/:w:/t/monarch/Ee7sP9tg_fFGtD4REu975aMBYMEOuxcbVxT4wtagnYoUJQ?e=eEursV
// the tl;dr is that you might want to limit the fields capable of being returned by a mutation, but have the mutation result update the
// full object in the cache.  this accomplishes that by rewriting __typename fields to match the full object type when they match the
// rfc's convention
export const partialResultIdMapperLink = () => {
    const link = new ApolloLink((operation, forward) => {
        const opNode = getOperationAST(operation?.query);
        const opTypeName = opNode?.operation;

        if (opTypeName === 'mutation') {
            return forward(operation).map(rewriteTypeNames);
        } else {
            return forward(operation);
        }
    });

    return link;
};

function rewriteTypeNames(result: FetchResult): FetchResult {
    rewriteTypeNamesImpl(result?.data, 0);
    return result;
}

const SANITY_CHECK = 100;

function rewriteTypeNamesImpl(o: object, depth: number): void {
    if (depth > SANITY_CHECK) {
        throw Error('Object too complex');
    }

    if (o) {
        Object.keys(o).forEach((key: string) => {
            const val = o[key];
            if (val) {
                if (key === '__typename' && typeof val === 'string') {
                    o[key] = rewriteTypeName(val);
                } else if (Array.isArray(val)) {
                    val.forEach(v => {
                        if (v && typeof v === 'object') {
                            rewriteTypeNamesImpl(v, depth + 1);
                        }
                    });
                } else if (typeof val === 'object') {
                    rewriteTypeNamesImpl(val, depth + 1);
                }
            }
        });
    }
}

function rewriteTypeName(typename: String): String {
    let rv = typename;

    if (typename?.indexOf('_') > -1) {
        let parts = typename.split('_');
        rv = parts[parts.length - 1];
    }

    return rv;
}
